import CenteredHeader from "./../../Molecules/CenteredHeader/CenteredHeader";
import DISTRIBUCION_SECTION_IMG from "../../../assets/img/DISTRIBUCION_SECTION_IMG.png";
import IndustryLightBlueSection from "./../../Organisms/IndustryLightBlueSection/IndustryLightBlueSection";
import "./IndustryDistribucion.scss";
import IndustryBannerBgSection from "../../Atoms/IndustryBannerBgSection/IndustryBannerBgSection";
import IndustryImageTextSection from "./../../Molecules/IndustryImageTextSection/IndustryImageTextSection";
import IndustryTwoButtonsSection from "./../../Atoms/IndustryTwoButtonsSection/IndustryTwoButtonsSection";
import DISTRIBUCION_DASHBOARD_IMG from "../../../assets/img/DISTRIBUCION_DASHBOARD_IMG.png";
import DITRIBUCION_CARACTERISTICAS_IMG from "../../../assets/img/DITRIBUCION_CARACTERISTICAS_IMG.png";
import IndustryFooterButtonSection from "./../../Atoms/IndustryFooterButtonSection/IndustryFooterButtonSection";
import DISTRIBUCION_ITEM_ICON_1 from "../../../assets/img/DISTRIBUCION_ITEM_ICON_1.svg";
import DISTRIBUCION_ITEM_ICON_2 from "../../../assets/img/DISTRIBUCION_ITEM_ICON_2.svg";
import DISTRIBUCION_ITEM_ICON_3 from "../../../assets/img/DISTRIBUCION_ITEM_ICON_3.svg";
import DISTRIBUCION_ITEM_ICON_4 from "../../../assets/img/DISTRIBUCION_ITEM_ICON_4.svg";
import DISTRIBUCION_ITEM_ICON_5 from "../../../assets/img/DISTRIBUCION_ITEM_ICON_5.svg";
import DISTRIBUCION_ITEM_ICON_6 from "../../../assets/img/DISTRIBUCION_ITEM_ICON_6.svg";
import RegularIconText from "../../Atoms/RegularIconText/RegularIconText";
import content from "./content";
import { useLanguageCtx } from "../../../store/providers/LanguageContext";
import ChangeableHeaderV2 from "../../Molecules/ChangeableHeaderV2/ChangeableHeaderV2";
import { useScrollCtx } from "../../../store/providers/ScrollContext";

const IndustryDistribucion = () => {
  const { language } = useLanguageCtx();
  const { dropdownHeader } = useScrollCtx();

  return (
    <>
      <ChangeableHeaderV2
        titleBanner={content[language].header_title}
        appearSecondNavbar={dropdownHeader}
        route="distribucion"
      />

      <div className="top-space-section">
        <CenteredHeader
          yellowText={content[language].distribucion_red_title}
          boldText={content[language].distribucion_bold_title}
        />
      </div>

      <div className="bottom-space-section max-width">
        <p className="body-18  center-text mt-40">
          {content[language].distribucion_text}
        </p>
        <img
          src={DISTRIBUCION_SECTION_IMG}
          alt="Distribución"
          className=" center mt-40 industryDistribucion--distribucion_img"
        />
        <div className="industryDistribucion-items-grid-design mt-40">
          <RegularIconText
            icon={DISTRIBUCION_ITEM_ICON_1}
            text={content[language].solucion_1}
            width="100%"
          />
          <RegularIconText
            icon={DISTRIBUCION_ITEM_ICON_2}
            text={content[language].solucion_2}
            width="100%"
          />
          <RegularIconText
            icon={DISTRIBUCION_ITEM_ICON_3}
            text={content[language].solucion_3}
            width="100%"
          />
          <RegularIconText
            icon={DISTRIBUCION_ITEM_ICON_4}
            text={content[language].solucion_4}
            width="100%"
          />
          <RegularIconText
            icon={DISTRIBUCION_ITEM_ICON_5}
            text={content[language].solucion_5}
            width="100%"
          />
          <RegularIconText
            icon={DISTRIBUCION_ITEM_ICON_6}
            text={content[language].solucion_6}
            width="100%"
          />
        </div>
      </div>

      <IndustryLightBlueSection
        yellowText={content[language].caracteristica_red_title}
        boldText={content[language].caracteristica_bold_text}
        checkText={content[language].caracteristica_list}
      />

      <IndustryBannerBgSection route="distribucion">
        <IndustryImageTextSection
          switchOrder
          funciones
          yellowText={content[language].funcionalidades_red_title}
          boldText={content[language].funcionalidades_bold_text}
          paragraphs={content[language].funcionalidades_text}
        />
      </IndustryBannerBgSection>

      <IndustryTwoButtonsSection bgColor="#F0F3F7" pt="80px" />

      <div
        className="all-width top-space-section bottom-space-section padding"
        style={{
          backgroundColor: "#F0F3F7",
        }}
      >
        <div className="bottom-space-section no-bottom-space-responsive">
          <CenteredHeader
            yellowText={content[language].dashboard_red_title}
            boldText={content[language].dashboard_bold_title}
          />
        </div>
        <IndustryImageTextSection
          image={{ img: DISTRIBUCION_DASHBOARD_IMG, alt: "Tablet" }}
          paragraphs={content[language].dashboard_text}
          checkText={content[language].dashboard_list}
          responsiveImgPosition="last"
        />
      </div>
      <div className="top-space-section bottom-space-section">
        <IndustryImageTextSection
          image={{
            img: DITRIBUCION_CARACTERISTICAS_IMG,
            alt: "Laptop con Gráficas",
          }}
          imgRadius
          yellowText={content[language].caracteristica_red_title}
          boldText={content[language].rutas_bold_text}
          paragraphs={content[language].rutas_text}
          checkText={content[language].rutas_list}
          responsiveImgPosition="last"
        />
      </div>

      <IndustryFooterButtonSection />
    </>
  );
};

export default IndustryDistribucion;
